import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import BlankButton from "@xo-union/component-blank-button";
import { createTrackableProps } from "@xo-union/tk-component-analytics";
import Icon from "@xo-union/tk-component-icons";
import cx from "classnames";
import { Row, Column } from "@xo-union/tk-component-grid";
import { useUniqueID } from "@xo-union/react-unique-id";
import styles from "../../../../../css/index.css";
const SectionGroup = props => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleSectionLabelClick = () => {
    setIsOpen(isOpenValue => !isOpenValue);
  };
  const {
    title,
    children,
    className = '',
    trackableProps: {
      selection
    }
  } = props;
  const titleID = useUniqueID();
  const listID = useUniqueID();
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-roledescription": "navigation level 2",
    "aria-labelledby": titleID,
    className: className
  }, /*#__PURE__*/React.createElement(BlankButton, _extends({
    className: styles.mobileSectionLabel,
    onClick: handleSectionLabelClick,
    type: "button",
    "aria-expanded": isOpen ? 'true' : 'false',
    "aria-controls": listID
  }, createTrackableProps({
    selection: isOpen ? `collapse-${selection}` : `expand-${selection}`
  })), title, /*#__PURE__*/React.createElement(Icon, {
    name: isOpen ? 'caret_up' : 'caret_down',
    size: "md"
  })), /*#__PURE__*/React.createElement("div", {
    role: "heading",
    "aria-level": "1",
    className: styles.desktopSectionLabel,
    id: titleID
  }, title), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.sectionItemsWrapper, !isOpen && styles.hidden)
  }, /*#__PURE__*/React.createElement("div", {
    id: listID,
    role: "list",
    className: styles.sectionItemsList
  }, children)));
};
process.env.NODE_ENV !== "production" ? SectionGroup.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  trackableProps: PropTypes.shape({
    selection: PropTypes.string.isRequired
  }).isRequired
} : void 0;
export const SectionGroupRow = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Row, {
    role: "presentation",
    className: styles.sectionGroupRow
  }, children);
};
process.env.NODE_ENV !== "production" ? SectionGroupRow.propTypes = {
  children: PropTypes.node.isRequired
} : void 0;
export const SectionColumn = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(Column, {
    role: "presentation",
    xs: "12",
    md: "6"
  }, children);
};
process.env.NODE_ENV !== "production" ? SectionColumn.propTypes = {
  children: PropTypes.node.isRequired
} : void 0;
export default SectionGroup;